import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import LoginPage from './pages/login/LoginPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import ProductListPage from './pages/product/ProductListPage';
import ProductFormPage from './pages/product/ProductFormPage';
import CategoryManagePage from './pages/category/CategoryManagePage';
import OrderListPage from './pages/order/OrderListPage';
import OrderDiscountManagePage from './pages/orderDiscount/OrderDiscountManagePage';
import StoreManagePage from './pages/store/StoreManagePage';
import TableOrderManagePage from './pages/tableorder/TableOrderManagePage';
import TableCallManagePage from './pages/tablecall/TableCallManagePage';
import ReservationManagePage from './pages/reservation/ReservationManagePage';
import ReviewManagePage from './pages/review/ReviewManagePage';
import BannerManagePage from './pages/banner/BannerManagePage';
import BrandManagePage from './pages/brand/BrandManagePage';
import MemberListPage from './pages/member/MemberListPage';
import AdminAccountListPage from './pages/account/AdminAccountListPage';
import MenuManagePage from './pages/menu/MenuManagePage';
import CodeManagePage from './pages/code/CodeManagePage';
import NoticeListPage from './pages/notice/NoticeListPage';
import LoginHistoryPage from './pages/history/LoginHistoryPage';
import UseHistoryPage from './pages/history/UseHistoryPage';
import PosSalesDashboardPage from './pages/posSales/PosSalesDashboardPage';
import PosSalesStatsPage from './pages/posSales/PosSalesStatsPage';
import AdminPushPage from './pages/push/AdminPushPage';
import RealtimeNotifier from './components/common/RealtimeNotifier';

import './styles/tokens.css';
import './styles/global.css';
import './styles/components/index.css';

function RootRedirect() {
  const { isAuthenticated } = useAuth();
  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/products" element={<ProductListPage />} />
          <Route path="/products/new" element={<ProductFormPage />} />
          <Route path="/products/:productId/edit" element={<ProductFormPage />} />
          <Route path="/categories" element={<CategoryManagePage />} />
          <Route path="/orders" element={<OrderListPage />} />
          <Route path="/order-discounts" element={<OrderDiscountManagePage />} />
          <Route path="/pos-sales" element={<PosSalesDashboardPage />} />
          <Route path="/sales-stats" element={<PosSalesStatsPage />} />
          <Route path="/stores" element={<StoreManagePage />} />
          <Route path="/brands" element={<BrandManagePage />} />
          <Route path="/table-orders" element={<TableOrderManagePage />} />
          <Route path="/table-calls" element={<TableCallManagePage />} />
          <Route path="/reservations" element={<ReservationManagePage />} />
          <Route path="/reviews" element={<ReviewManagePage />} />
          <Route path="/banners" element={<BannerManagePage />} />

          {/* 고객용 QR오더 화면은 front-web(고객용 웹서비스)으로 이관되었다
              (frontend/front-web/src/pages/QrOrderPage.jsx, 경로 /order/:qrToken). */}

          <Route path="/members" element={<MemberListPage />} />
          <Route path="/accounts" element={<AdminAccountListPage />} />
          <Route path="/menus" element={<MenuManagePage />} />
          <Route path="/codes" element={<CodeManagePage />} />
          <Route path="/notices" element={<NoticeListPage />} />
          <Route path="/history/login" element={<LoginHistoryPage />} />
          <Route path="/history/use" element={<UseHistoryPage />} />
          <Route path="/push-message" element={<AdminPushPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      {/* 로그인 상태의 어느 화면에서든 슈퍼관리자 실시간 메시지를 토스트로 띄운다(전역 SSE 구독). */}
      <RealtimeNotifier />
    </AuthProvider>
  );
}
